<template>
  <div>
    <div class="sub_top">
      <SubTitle></SubTitle>
      <div class="sub_tit">
        <div class="sub_tit_inner">
          <h2>공유플랫폼의 중요성</h2>
        </div>
      </div>
    </div>

    <!-- container : S -->
    <div class="ptc_container">
      <div class="info_section">
        <div class="info_txt">
          <p class="txt_typ_1">소재연구데이터 중, 90% 이상이</p>
          <p class="txt_typ_2">"측정·분석데이터"</p>
        </div>
        <div class="info_graphic">
          <div class="info_graphic_img">
            <img :src="require(`@/style/new/images/info/platform_01.png`)" alt="" />
          </div>
        </div>
      </div>
    </div>
    <!-- container : E -->
  </div>
  <!-- wrap : E -->

  <!--  <div class="mt-5 pt-lg-5">
      <b-container class="pb-lg-3">
        <content-header title="공유플랫폼의 필요성" />
      </b-container>
      <div class="py-5">
        <b-row align-h="center">
          <b-col
            cols="12"
            md="11"
            lg="11"
            class="px-0 px-md-3 mb-4 mb-lg-5 position-relative"
            :style="{ backgroundColor: '#F5F6F9', borderRadius: '20px' }"
          >
            <div class="p-5 px-md-3">
              <header class="text-16 text-md-24 text-center">
                <span class="">소재연구데이터 중,</span>
                <h2 class="text-platform fw-600 mt-2">90% 이상이 “측정·분석데이터”</h2>
              </header>
            </div>
            <b-row align-h="center" class="pb-5" align-v="stretch">
              <b-col cols="11" lg="6">
                <img src="@/assets/platform/protocol/necessity.png" alt="" />
              </b-col>
              <b-col cols="11" lg="4" class="my-lg-3 py-lg-5">
                <div
                  class="bg-white p-4 p-lg-5 w-100 h-100 d-flex flex-column align-items-stretch"
                  :style="{ borderRadius: '15px', border: '1px solid #EAECF0' }"
                >
                  <div
                    class="h-100 my-auto d-flex flex-column align-items-center justify-content-center"
                    v-for="(p, i) in texts"
                    :key="i"
                    :style="i % 2 ? { borderTop: '1px solid #EAECF0', borderBottom: '1px solid #EAECF0' } : {}"
                  >
                    <p class="m-0 text-14 text-md-16 p-2 lh-180 fw-300" :style="{ color: '#404040' }" v-html="p" />
                  </div>
                </div>
              </b-col>
            </b-row>
            <div class="position-absolute" :style="{ bottom: '0', left: '50%', transform: 'translate(-50%, 75%)' }">
              <img src="@/assets/platform/protocol/arrow-gradient.png" :style="{ width: '160px' }" />
            </div>
          </b-col>
          <b-col cols="11" md="6" lg="5" class="my-4">
            <div class="w-100 text-center p-2 rounded-pill shadow" :style="{ border: '1px solid #eaecf0' }">
              <div class="p-2">
                <div
                  class="w-100 h-100 rounded-pill px-5 py-4"
                  :style="{
                    background: 'linear-gradient(38.06deg, #E44C29 0.56%, #0dbde9 0.56%, #F46D4D 134.78%)',
                  }"
                >
                  <span class="text-white text-18 text-md-22 fw-600"> 측정분석데이터의 적극 활용으로 원천소재 기술 개발 주기 가속화 가능 </span>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>-->
</template>

<script>
import MiddleContainer from "@/components/platform/MiddleContainer";
import ContentHeader from "@/components/platform/ContentHeader";
import SubTitle from "@/views/Platform/Introduce/SubTitle";

export default {
  components: {
    MiddleContainer,
    ContentHeader,
    SubTitle
  },
  data() {
    return {

      texts: [
        "측정·분석을 통해 소재 설계 및 공정을 통해 <br class='d-none d-lg-block'> 변화된 물성을 측정하고 물성 변화의 메커니즘을 <br class='d-none d-lg-block'> 소재 내 다양한 구조 관찰 및 분석을 통해 규명",
        "소재의 나노화/복합화에 따라  <br class='d-none d-lg-block'> 게임체인저 급의 소재 측정·분석 신기술이 요구",
        "차세대 신소재 원천기술 개발은  <br class='d-none d-lg-block'> 차세대 소재 측정·분석기술이 중요한 축을 담당",
      ],
      links: [
        {
          name: "사업개요",
          url: "overview",
        },
        {
          name: "공유플랫폼의 필요성",
          url: "necessity",
        },
        {
          name: "운영전략",
          url: "strategy",
        },
        {
          name: "연구단구성",
          url: "member",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
